import React from "react";

export const Footer = () => {
  return (
    <footer className="other:w-full med:w-full  max320:w-full medium:w-full">
      <div className="h-[5rem]  dark:bg-slate-900  lg:min-w-[80rem] medium:min-w-[60rem] dark:text-white  shadow-md flex items-center justify-center">
          <span>©2023 Bardi-Write. All Rights Reserved</span>
      </div>
    
    </footer>
  )
}